import React, { useEffect } from 'react'
import { BrowserRouter, HashRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Home from '../Pages/Home';
import Warehouse from '../Pages/Warehouse';
import WarehouseOrders from '../Pages/WarehouseOrders';
import Main from '../Pages/Main';
import Fittings from '../Pages/Fittings';
import FittingsOrders from '../Pages/Fittingsorders';
import { useParams } from 'react-router-dom';
import OrderHistory from '../Pages/OrderHistory';
import Test from '../test';
import Test1 from '../test1';
import WarehouseOrdersNew from '../Pages/WarehouseOrdersNew';

// const PublicRoute = ({ children }) => {
//     const { id } = useParams();
//     return localStorage.getItem("token") ? (
//         <>
//             <Navbar />
//             {children}
//         </>
//     ) : (
//         <Navigate to={`/${id}`} replace={true} />
//     );
// };

// const PublicRoute = ({ children }) => {
//     return (
//         <>
//             <Navbar />
//             {children}
//         </>
//     )
// }
const PublicRoute = ({ children }) => {
    const { id } = useParams();

    let token;

    token = sessionStorage.getItem("token");

    return token ? (
        <>
            <Navbar />
            {children}
        </>
    ) : (
        <Navigate to={`/${id}`} replace={true} />
    );
};


const Routing = () => {
    return (
        <BrowserRouter basename="/pos">
            <Routes>
                {/* HOME */}
                <Route path="/:id" element={<Main />} />
                <Route path="/warehouse/:id" element={<PublicRoute><Home /></PublicRoute>} />
                {/* Warehouse */}
                <Route path="/warehouse_orders/:id" element={<PublicRoute><Warehouse /></PublicRoute>} />
                <Route path="/warehouse_orders/orders/:id" element={<PublicRoute><WarehouseOrdersNew /></PublicRoute>} />
                {/* <Route path="/warehouse/lists/:id" element={<PublicRoute><WarehouseOrders /></PublicRoute>} /> */}
                {/* <Route path="/warehouse_orders/orders/:id/tab_web" element={<PublicRoute><WarehouseOrders index={"web"} /></PublicRoute>} />
                <Route path="/warehouse_orders/orders/:id/tab_transfer" element={<PublicRoute><WarehouseOrders index={"transfer"} /></PublicRoute>} /> */}
                <Route path="/warehouse_orders/orders/:id/tab_to_pick" element={<PublicRoute><WarehouseOrders index={"to_pick"} expressIndex="to_pick_order_to_be_printed" /></PublicRoute>} />
                <Route path="/warehouse_orders/orders/:id/tab_to_pick_order_to_be_printed" element={<PublicRoute><WarehouseOrders index={"to_pick"} expressIndex="to_pick_order_to_be_printed" /></PublicRoute>} />
                <Route path="/warehouse_orders/orders/:id/tab_to_pick_printed_orders" element={<PublicRoute><WarehouseOrders index={"to_pick"} expressIndex="to_pick_printed_orders" /></PublicRoute>} />
                <Route path="/warehouse_orders/orders/:id/tab_to_prepare" element={<PublicRoute><WarehouseOrders index={"to_prepare"} /></PublicRoute>} />
                <Route path="/warehouse_orders/orders/:id/tab_pickup" element={<PublicRoute><WarehouseOrders index={"pickup"} /></PublicRoute>} />
                <Route path="/warehouse_orders/orders/:id/tab_ready_to_be_picked" element={<PublicRoute><WarehouseOrders index={"ready_to_be_picked"} /></PublicRoute>} />
                <Route path="/warehouse_orders/orders/:id/tab_invoiced" element={<PublicRoute><WarehouseOrders index={"invoiced"} /></PublicRoute>} />
                <Route path="/warehouse_orders/orders/:id/tab_picked" element={<PublicRoute><WarehouseOrders index={"picked"} /></PublicRoute>} />
                <Route path="/warehouse_orders/orders/:id/tab_notification" element={<PublicRoute><WarehouseOrders index="notification" /></PublicRoute>} />
                {/* <Route path="/warehouse/orders/:id/tab6" element={<PublicRoute><WarehouseOrders index={6} /></PublicRoute>} /> */}

                {/* Warehouse */}

                {/* Fittings Orders */}
                <Route path="/fittings/:id" element={<PublicRoute><Fittings /></PublicRoute>} />
                <Route path="/fittings/orders/:id" element={<PublicRoute><FittingsOrders /></PublicRoute>} />
                <Route path="/fittings/orders/:id/tab_express" element={<PublicRoute><FittingsOrders index="express" expressIndex="express_order_to_be_printed" /></PublicRoute>} />
                <Route path="/fittings/orders/:id/tab_express_order_to_be_printed" element={<PublicRoute><FittingsOrders index="express" expressIndex="express_order_to_be_printed" /></PublicRoute>} />
                <Route path="/fittings/orders/:id/tab_express_printed_orders" element={<PublicRoute><FittingsOrders index="express" expressIndex="express_printed_orders" /></PublicRoute>} />


                <Route path="/fittings/orders/:id/tab_instore" element={<PublicRoute><FittingsOrders index="instore" instoreIndex="instore_order_to_be_printed" /></PublicRoute>} />
                <Route path="/fittings/orders/:id/tab_instore_order_to_be_printed" element={<PublicRoute><FittingsOrders index="instore" instoreIndex="instore_order_to_be_printed" /></PublicRoute>} />
                <Route path="/fittings/orders/:id/tab_instore_printed_orders" element={<PublicRoute><FittingsOrders index="instore" instoreIndex="instore_printed_orders" /></PublicRoute>} />


                <Route path="/fittings/orders/:id/tab_pickup" element={<PublicRoute><FittingsOrders index="pickup" /></PublicRoute>} />
                <Route path="/fittings/orders/:id/tab_fulfilled" element={<PublicRoute><FittingsOrders index="fulfilled" /></PublicRoute>} />
                <Route path="/fittings/orders/:id/tab_notification" element={<PublicRoute><FittingsOrders index="notification" /></PublicRoute>} />
                <Route path="/fittings/orders/:id/tab_ready_to_be_picked" element={<PublicRoute><FittingsOrders index="ready_to_be_picked" /></PublicRoute>} />
                {/* Fittings Orders */}

                {/* Order History */}
                <Route path="/order_history/:id" element={<PublicRoute><OrderHistory /></PublicRoute>} />
                {/* Order History */}

                {/* Notifications */}
                {/* <Route path="/notification" element={<PublicRoute><Notifications /></PublicRoute>} /> */}
                {/* Notifications */}

                {window.location.hostname === "localhost" &&
                    <>
                        <Route path="/test" element={<Test />} />
                        <Route path="/test1" element={<Test1 />} />
                        <Route path="/test2" element={<WarehouseOrdersNew />} />
                    </>
                }

            </Routes>
        </BrowserRouter>
    );
}

export default Routing;
